const GET_TAXPAYER_VOLUME_DATA = 'GET_TAXPAYER_VOLUME_DATA';
const SET_TAXPAYER_VOLUME_DATA = 'SET_TAXPAYER_VOLUME_DATA';
const GENERATE_VOLUME_REQUEST = 'GENERATE_VOLUME_REQUEST';
const CALCULATE_VOLUME_PROCESS = 'CALCULATE_VOLUME_PROCESS';

const getTaxpayerVolumeData = () => {
    return {
        type: GET_TAXPAYER_VOLUME_DATA        
    }
}

const setTaxpayerVolumeData = data => {
    return {
        type: SET_TAXPAYER_VOLUME_DATA,
        data
    }
}

const generateVolumeRequest = taxId => {
    return {
        type: GENERATE_VOLUME_REQUEST,
        taxId
    }
}

const calculateVolumeProcess = data =>{
    return{
        type: CALCULATE_VOLUME_PROCESS,
        data
    }
}

export default {
    types: {        
        GET_TAXPAYER_VOLUME_DATA,
        SET_TAXPAYER_VOLUME_DATA,
        GENERATE_VOLUME_REQUEST,
        CALCULATE_VOLUME_PROCESS
    },
    actions: {
        getTaxpayerVolumeData,
        setTaxpayerVolumeData,
        generateVolumeRequest,
        calculateVolumeProcess
    }
}
